'use client'

import { Flex, Text, Box, Link } from '@chakra-ui/react'
import NextLink from 'next/link'
import { PRODUCT_NAME } from '@/lib/constants/brand'

interface BrandLogoProps {
  /** When true, hides the wordmark on very narrow viewports. */
  compact?: boolean
  /** Destination when the logo is clicked. Defaults to the app homepage. */
  href?: string
}

/** Classic eye mark + product wordmark for header and shell branding. */
export default function BrandLogo({ compact = false, href = '/' }: BrandLogoProps) {
  return (
    <Link
      as={NextLink}
      href={href}
      _hover={{ textDecoration: 'none', opacity: 0.92 }}
    >
      <Flex align="center" gap={2.5} minW={0}>
        <Box
          flexShrink={0}
          w={9}
          h={9}
          borderRadius="lg"
          bg="accent"
          display="flex"
          alignItems="center"
          justifyContent="center"
          shadow="sm"
          aria-hidden
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M2.5 10C4.2 6.8 6.8 5 10 5s5.8 1.8 7.5 5c-1.7 3.2-4.3 5-7.5 5s-5.8-1.8-7.5-5Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
            <circle cx="10" cy="10" r="2.25" fill="white" />
          </svg>
        </Box>
        <Text
          fontSize={{ base: 'md', md: 'lg' }}
          fontWeight="bold"
          color="accent"
          letterSpacing="-0.01em"
          noOfLines={1}
          display={{ base: compact ? 'none' : 'block', sm: 'block' }}
        >
          {PRODUCT_NAME}
        </Text>
      </Flex>
    </Link>
  )
}
